import { Box, Title } from '@mantine/core';
import React from 'react';

import { ProductTypeEnum } from '@portals/api/partners';

import { CreateModeNavigation } from './CreateModeNavigation';
import { EditModeNavigation } from './EditModeNavigation';
import { ProductWizardContext } from '../types';
import { useProductWizard } from '../use-product-wizard';

interface NavigationColumnProps {
  isEdit: boolean;
}

export function NavigationColumn({ isEdit }: NavigationColumnProps) {
  const { contextData } = useProductWizard();

  const title = getTitle(contextData.product?.product_type);

  return (
    <Box p={30}>
      <Title order={3} weight={600} mb={44}>
        {title}
      </Title>

      {isEdit ? <EditModeNavigation /> : <CreateModeNavigation />}
    </Box>
  );
}

function getTitle(
  productType: ProductWizardContext['product']['product_type']
) {
  switch (productType) {
    case ProductTypeEnum.Physical:
      return 'Physical Product';
    case ProductTypeEnum.Digital:
      return 'Digital Product';
    default:
      return 'TBD';
  }
}
